export default function ReportAccountSuspension() {
  return (
    <a href="mailto:hi@angellistindia.com" className="text-sm font-semibold text-gray-900">
      Contact support <span aria-hidden="true">&rarr;</span>
    </a>
  );
}
